import { render } from "./MainDashboard.vue?vue&type=template&id=7ef1d176"
import script from "./MainDashboard.vue?vue&type=script&lang=js"
export * from "./MainDashboard.vue?vue&type=script&lang=js"

import exportComponent from "E:\\workspacev\\vue_myLogin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__